import React from 'react';
import PropTypes from 'prop-types';
import InputWithButton from '../../Common/InputWithButton/InputWithButton';

const AccessCodeStep = ({ userRequest, onContinue, onFormChange, isFormValid }) => {
    const valid = isFormValid ? "" : "was-validated";
    const className = "access-code-form " + valid;

    const onChange = (e) => {
        onFormChange(e.target.name, e.target.value);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onContinue();
    }

    return (
        <form name="access-code-form" onSubmit={onSubmit} className={className} noValidate>
            <InputWithButton
                name="accessCode"
                type="text"
                placeholder="Access Code"
                value={userRequest.accessCode}
                onChange={onChange}
                isFocused={true}
                isRequired={true}
                errorMessage="Please enter an access code"
                showButton={true}
                onButtonClick={onSubmit}
            />
            <strong>Need an access code?</strong>
            <div>Ask your colleagues or refer to documentation provided by your company&apos;s administrator.</div>
        </form>
    );
};

AccessCodeStep.propTypes = {
    userRequest: PropTypes.object.isRequired,
    onContinue: PropTypes.func.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired
};

export default AccessCodeStep;
